import type { LoaderFunction } from "@remix-run/node";
import { json } from "@remix-run/node";

import { withCors } from "~/config/cors";
import { PRODUCT_NAME } from "~/lib/env.shared";
import { pageMeta } from "~/utils/meta";
import Terms from "~/pages/Terms";

export const meta = pageMeta(
    `Terms of Service - ${PRODUCT_NAME}`,
    `${PRODUCT_NAME} Terms of Service`,
);

export const loader: LoaderFunction = withCors(async ({ request }) => json({}));

export default function TermsRoute() {
    return <Terms />;
}
